var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFerreteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.955,
    height: 86.955,
    viewBox: "0 0 86.955 86.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1923",
    "data-name": "Grupo 1923",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-tool-box",
    "data-name": "001-tool-box",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_203",
    "data-name": "Trazado 203",
    d: "M86.552,45.88h-1.4V13.622A7.02,7.02,0,0,0,78.137,6.61H52.892V2.4A1.4,1.4,0,0,0,51.49,1H37.465a1.4,1.4,0,0,0-1.4,1.4V6.61H10.817A7.02,7.02,0,0,0,3.8,13.622V45.88H2.4a1.4,1.4,0,0,0-1.4,1.4V79.54a8.423,8.423,0,0,0,8.415,8.415H79.54a8.423,8.423,0,0,0,8.415-8.415V47.282A1.4,1.4,0,0,0,86.552,45.88ZM38.867,3.8h11.22v2.8H38.867ZM6.61,13.622a4.213,4.213,0,0,1,4.207-4.207h67.32a4.213,4.213,0,0,1,4.207,4.207V45.88h-2.8V13.622a1.4,1.4,0,0,0-1.4-1.4H10.817a1.4,1.4,0,0,0-1.4,1.4V45.88H6.61Zm36.318,16.2-1.255-2.509V23.44h5.61v3.876l-1.255,2.509a1.406,1.406,0,0,0-.147.627v8.415h-2.8V30.452A1.406,1.406,0,0,0,42.928,29.825Zm5.757,11.847V45.88H40.27V41.672Zm-9.817,7.012h11.22v5.61H38.867Zm12.622-2.8V40.27a1.4,1.4,0,0,0-1.4-1.4h-1.4V30.783l1.255-2.509a1.406,1.406,0,0,0,.147-.627v-5.61a1.4,1.4,0,0,0-1.4-1.4H40.27a1.4,1.4,0,0,0-1.4,1.4v5.61a1.406,1.406,0,0,0,.147.627l1.255,2.509v8.084h-1.4a1.4,1.4,0,0,0-1.4,1.4v5.61H29.05V38.4a9.806,9.806,0,0,0-.934-18.11,1.4,1.4,0,0,0-1.871,1.323v7.345l-1.4,1.4-1.4-1.4V21.612a1.4,1.4,0,0,0-1.871-1.321,9.806,9.806,0,0,0-.934,18.11V45.88H12.22V15.025H76.735V45.88H68.32V38.4a9.806,9.806,0,0,0-.934-18.11,1.4,1.4,0,0,0-1.871,1.323v7.345l-1.4,1.4-1.4-1.4V21.612a1.4,1.4,0,0,0-1.871-1.321A9.806,9.806,0,0,0,59.9,38.4V45.88ZM15.025,59.9H23.44v2.8H15.025Zm8.415-2.8H15.025V48.685H23.44Zm-.934-20.957a7,7,0,0,1-1.871-12.2v5.6a1.4,1.4,0,0,0,.411.992l2.8,2.8a1.4,1.4,0,0,0,1.983,0l2.8-2.8a1.4,1.4,0,0,0,.411-.992v-5.6a7,7,0,0,1-1.871,12.2,1.4,1.4,0,0,0-.934,1.323V45.88h-2.8V37.465a1.4,1.4,0,0,0-.934-1.323Zm39.27,0a7,7,0,0,1-1.871-12.2v5.6a1.4,1.4,0,0,0,.411.992l2.8,2.8a1.4,1.4,0,0,0,1.983,0l2.8-2.8a1.4,1.4,0,0,0,.411-.992v-5.6a7,7,0,0,1-1.871,12.2,1.4,1.4,0,0,0-.934,1.323V45.88H62.71V37.465A1.4,1.4,0,0,0,61.776,36.142ZM65.515,59.9H73.93v2.8H65.515Zm8.415-2.8H65.515V48.685H73.93ZM85.15,79.54a5.616,5.616,0,0,1-5.61,5.61H9.415A5.616,5.616,0,0,1,3.8,79.54V48.685H12.22V64.112a1.4,1.4,0,0,0,1.4,1.4h11.22a1.4,1.4,0,0,0,1.4-1.4V48.685h9.817V55.7a1.4,1.4,0,0,0,1.4,1.4H51.49a1.4,1.4,0,0,0,1.4-1.4V48.685H62.71V64.112a1.4,1.4,0,0,0,1.4,1.4h11.22a1.4,1.4,0,0,0,1.4-1.4V48.685H85.15Z",
    transform: "translate(-1 -1)",
    fill: "#003082"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_2",
    "data-name": "L\\xEDnea 2",
    x2: 54.697,
    transform: "translate(25.946 79.242)",
    fill: "none",
    stroke: "#86888b",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_3",
    "data-name": "L\\xEDnea 3",
    y1: 25.245,
    transform: "translate(80.644 53.997)",
    fill: "none",
    stroke: "#86888b",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerreteria);
export default __webpack_public_path__ + "static/media/ferreteria.fd92da39591b45c1e21aa982a4aec3a1.svg";
export { ForwardRef as ReactComponent };